/**
 * Routes that are ALWAYS light, whatever theme the user picked.
 *
 * There is one, and it is the login page. The captain's login target is a
 * zinc-100 page carrying the WasteHero wordmark, and the wordmark ships in one
 * colourway — a dark navy lockup that is legible on light and invisible on
 * dark. So the page is a fixed light surface by design, not by omission.
 *
 * `AuthLayout`'s light shell re-scopes the two TOKEN systems for itself: a
 * `data-theme="light"` on its wrapper turns `--wh-*` (`src/styles/ThemeVars.ts`)
 * and the shadcn semantic set (`src/styles/tailwind.css`) light for its whole
 * subtree, which is the repo's existing force-light-island mechanism (the
 * PDF/print panels use the same one). antd is the one thing that cannot be
 * re-scoped that way: its light-vs-dark ALGORITHM is chosen once, at the root
 * `ConfigProvider` in `src/App/AntdI18n.tsx`, and cssinjs writes the result
 * into unhashed `.ant-*` rules — so a nested provider would not scope the
 * change, it would overwrite those rules for the rest of the session. This
 * predicate is how that one provider learns to pick light instead.
 *
 * Leaf module on purpose: `AntdI18n` is boot-static (PRO-130), so this must
 * import nothing.
 */

/** Exact pathnames that pin the app light. Keep in step with whichever page
 *  passes `surface="light"` to `AuthLayout` — today only `src/pages/login`. */
export const LIGHT_SURFACE_PATHS = ['/login']

/** Trailing slashes reach the same route (react-router matches `exact`
 *  non-strictly), so they must resolve the same way here. */
export const isLightSurfacePath = (pathname: string): boolean =>
  LIGHT_SURFACE_PATHS.includes(pathname.replace(/\/+$/, '') || '/')
